<script>
export default {
  inject:['gsap'],
  name: "TitleBannersOurProjects",
  mounted() {
    var element = $(".new-places.our-projects")
    this.gsap.to('.new-places.our-projects', {
      duration: 2,
      delay:2,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active", // Добавляем/убираем класс "active" при срабатывании триггера
        once:true
      }
    });
  }
}
</script>

<template>
  <div class="new-places our-projects left">
    <div class="green-line-op mobile">
    </div>

    <span class="accent-title our-projects left">Положительный опыт <br>в инвестиционных проектах</span>
    <div class="our-projects-container-img first left">
      <img src="/assets/our1.jpg" alt="our-projects-1">
    </div>
    <div class="our-projects-container-img-second left">
      <img src="/assets/our2.webp" alt="our-projects-2">
<!--      <router-link :to="{path : '/ourprojects', hash: '#liner'}" class="geo-info left flex flex-xy-center">-->

<!--        <div class="circle-white flex flex-xy-center">-->
<!--          <svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2753 15.7943C49.9082 22.1867 49.9082 34.2057 42.2753 40.5981L32.4798 51.3723C31.6863 52.2451 30.3137 52.2451 29.5202 51.3723L19.7247 40.5981C12.0918 34.2057 12.0918 22.1867 19.7247 15.7943C27.3577 9.40191 34.6423 9.4019 42.2753 15.7943ZM31 35C34.866 35 38 31.866 38 28C38 24.134 34.866 21 31 21C27.134 21 24 24.134 24 28C24 31.866 27.134 35 31 35Z" fill="#FF9166"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span>ЖК “Лайнер Восток”</span>-->
<!--      </router-link>-->
    </div>
    <div class="our-projects-container-img-thrid left">
      <img src="/assets/our3.jpg" alt="our-projects-3">
<!--      <router-link :to="{path : '/ourprojects', hash: '#liner'}" class="geo-info left flex flex-xy-center">-->

<!--        <div class="circle-white flex flex-xy-center">-->
<!--          <svg width="61" height="62" viewBox="0 0 61 62" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path fill-rule="evenodd" clip-rule="evenodd" d="M42.2753 15.7943C49.9082 22.1867 49.9082 34.2057 42.2753 40.5981L32.4798 51.3723C31.6863 52.2451 30.3137 52.2451 29.5202 51.3723L19.7247 40.5981C12.0918 34.2057 12.0918 22.1867 19.7247 15.7943C27.3577 9.40191 34.6423 9.4019 42.2753 15.7943ZM31 35C34.866 35 38 31.866 38 28C38 24.134 34.866 21 31 21C27.134 21 24 24.134 24 28C24 31.866 27.134 35 31 35Z" fill="#FF9166"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <span>ЖК “Лайнер Запад”</span>-->
<!--      </router-link>-->

    </div>
    <svg class="green-title" width="1700" height="618" viewBox="0 0 1700 618" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-37.5 418C222 170 797.615 186.003 565.962 379.53C276.396 621.44 1095.56 684.454 1423.99 495.593C1775.86 293.253 1620.7 22.9132 1622 12M1622 12C1625.24 25.3383 1630.57 60.273 1602.59 89.3748M1622 12C1642.08 23.5195 1684.89 44.3705 1688 54.5562" stroke="#B2DBBF" stroke-width="24" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</template>

<style scoped>

</style>